/** Path-based routing (the Worker serves index.html for every path). */
export type Route = { name: 'library' } | { name: 'editor'; id: string } | { name: 'signin' } | { name: 'admin' };

export function parseRoute(pathname = location.pathname): Route {
  const m = /^\/m\/([a-f0-9]{8,40})\/?$/.exec(pathname);
  if (m) return { name: 'editor', id: m[1]! };
  if (pathname === '/signin') return { name: 'signin' };
  if (pathname === '/admin') return { name: 'admin' };
  return { name: 'library' };
}

export function routePath(r: Route): string {
  switch (r.name) {
    case 'editor':
      return `/m/${r.id}`;
    case 'signin':
      return '/signin';
    case 'admin':
      return '/admin';
    default:
      return '/';
  }
}

const listeners = new Set<(r: Route) => void>();

export function navigate(r: Route, replace = false): void {
  const path = routePath(r);
  if (path !== location.pathname) {
    if (replace) history.replaceState(null, '', path);
    else history.pushState(null, '', path);
  }
  for (const l of listeners) l(r);
}

export function onRoute(fn: (r: Route) => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

window.addEventListener('popstate', () => {
  const r = parseRoute();
  for (const l of listeners) l(r);
});
